import React, { Component } from 'react';
import Cursor from '../../assets/css/ying.gif';

let lastMouseX = typeof window !== 'undefined' ? window.innerWidth / 2 : 0;
let lastMouseY = typeof window !== 'undefined' ? window.innerHeight / 2 : 0;
if (typeof window !== 'undefined') {
    window.addEventListener('mousemove', (e) => {
        lastMouseX = e.clientX;
        lastMouseY = e.clientY;
    }, { passive: true });
}

class AnimatedCursor extends Component {

    state = {
        y: lastMouseY - 20,
        x: lastMouseX - 20,
        visible: 'visible'
    }

    componentDidMount() {
        window.addEventListener('mousemove', this.animateCursor, false);
        document.addEventListener('mouseleave', this.hideCursor, false);
    }

    animateCursor = (e) => {
        this.setState({
            y: e.clientY - 20,
            x: e.clientX - 20,
            visible: 'visible'
        })
    }

    hideCursor = () => {
        this.setState({ visible: 'hidden' });
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.animateCursor, false);
        document.removeEventListener('mouseleave', this.hideCursor, false);
    }

    render() {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: this.state.y,
                    left: this.state.x,
                    visibility: this.state.visible,
                    pointerEvents: 'none'
                }}>
                <img style={{ width: '30px' }} src={Cursor} alt="" />
            </div>
        );
    }
}

export default AnimatedCursor;


// WEBPACK FOOTER //
// ./src/Posts/elements/AnimatedCursor.js